import * as React from "react";
import '../../../../node_modules/react-vis/dist/style.css';
import {XYPlot, VerticalGridLines, HorizontalGridLines, VerticalBarSeries, XAxis, YAxis} from 'react-vis';
import Panel from "../core/Panel";
import * as moment from "moment";
import Loader from "../core/Loader";
import jfetch from "../../utils/jfetch";
import toast from "../../utils/toast";
import styled from "styled-components";

interface IProps {
}

interface IState {
  data: any,
  isLoading: boolean,
  period: string,
  duration: number
}

const SelectContainer = styled.div`
  width: 100%;
  display: inline-block;
  padding: 10px;
`;

const EmptyDiv = styled.div`
  min-height: 342px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ChartContainer = styled.div`
  min-width: 500px;
  min-width: 342px;
`;

const NoteContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
`;

const periodOptions = ["daily", "weekly", "monthly", "yearly"];

class CourseViewsChart extends React.Component<IProps, IState> {

  state: IState = {
    data: [],
    isLoading: false,
    period: periodOptions[0],
    duration: 7
  };

  componentDidMount(): void {
    this.getCourseViewsData(this.state.period);
  }

  getCourseViewsData = async (period: string) => {
    this.setState({isLoading: true});
    try {
      const data = await jfetch.get(`course_views_graph/${period}/${this.state.duration}`);
      if (data.status === "ok") {
        const formattedData = this.formatCourseViewsData(data.data.reverse());
        this.setState({
          data: formattedData,
          isLoading: false
        });
      }
    } catch (e) {
      toast.error("Error retrieving course views data");
    }
  };

  formatCourseViewsData = (data: any) => {
    const formattedData = [];
    for (let i = 0; i < this.state.duration; i++) {
      const viewDate = data[0] ? this.getMomentDate(0, data[0]['x']) : null;
      const today = this.getMomentDate(i, null);
      if (viewDate && today.isSame(viewDate, 'd')) {
        formattedData.unshift(this.dateBuilder(viewDate, data[0]['y']));
        data.shift();
      } else {
        formattedData.unshift(this.dateBuilder(today, 0));
      }
    }
    return formattedData;
  };

  dateBuilder = (momentDate, val) => {
    switch(this.state.period) {
      case "daily":
      case "weekly":
        return {'x': momentDate.format('MM/DD/YYYY'), 'y': val};
      case "monthly":
        return {'x': momentDate.format('MMM YY'), 'y': val};
      case "yearly":
        return {'x': momentDate.format('YYYY'), 'y': val};
    }
  };

  getMomentDate = (i, day) => {
    const momentDate = day ? moment.utc(day) : moment.utc();
    switch(this.state.period) {
      case "daily":
        return momentDate.subtract(i, 'day');
      case "weekly":
        return momentDate.startOf('isoWeek').subtract(i, 'week');
      case "monthly":
        return momentDate.startOf('month').subtract(i, 'month');
      case 'yearly':
        return momentDate.startOf('year').subtract(i, 'year');
    }
  };

  handleOptionsChange = (option) => {
    if (option !== this.state.period) {
      this.getCourseViewsData(option);
    }
    this.setState({period: option});
  };

  render() {

    const {data, isLoading} = this.state;

    return (
      <Panel heading={"Course Views"}>
        <ChartContainer>
        {
          isLoading
            ? <EmptyDiv><Loader/></EmptyDiv>
            : (
                <>
                  <SelectContainer>
                    <div className="buttons has-addons is-centered">
                      {
                        periodOptions.map((option, key) => {
                          return (
                            <span
                              key={key}
                              className={'button ' + (this.state.period === option ? "is-info is-selected" : "")}
                              onClick={() => this.handleOptionsChange(option)}
                            >
                              {option.toUpperCase()}
                            </span>
                          );
                        })
                      }
                    </div>
                  </SelectContainer>
                  <XYPlot xType="ordinal" height={300} width= {500}>
                    <VerticalGridLines />
                    <HorizontalGridLines />
                    <XAxis />
                    <YAxis />
                    <VerticalBarSeries data={data} />
                  </XYPlot>
                  <NoteContainer>
                    * Course views are aggregated from lesson views
                  </NoteContainer>
                </>
              )
        }
        </ChartContainer>
      </Panel>
    );
  }
}

export default CourseViewsChart;



// WEBPACK FOOTER //
// ./app/javascript/components/report/CourseViewsChart.tsx